import { SITE_URL } from '@/lib/seo';
import { useLanguage } from '@/contexts/LanguageContextNew';
import { useSchemaDOM } from '@/hooks/useSchemaDOM';

interface ServiceAuthoritySchemasProps {
  serviceName: string;
  category: 'bpo' | 'digital' | 'consulting';
}

export function ServiceAuthoritySchemas({ serviceName, category }: ServiceAuthoritySchemasProps) {
  const { language } = useLanguage();

  const profileSchema = {
    '@context': 'https://schema.org', '@type': 'ProfilePage',
    '@id': `${SITE_URL}/${language}/leadership#profilepage`,
    name: 'Call IT Dev Leadership Team', inLanguage: language,
  };

  const eventSchema = {
    '@context': 'https://schema.org', '@type': 'Event',
    name: 'Call IT Dev BPO Masterclass 2026',
    startDate: '2026-03-15T14:00:00+01:00',
    eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
    organizer: { '@type': 'Organization', '@id': `${SITE_URL}/#organization` },
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
    inLanguage: language,
  };

  useSchemaDOM([profileSchema, eventSchema], `service-authority-${serviceName.toLowerCase().replace(/\s+/g, '-')}`, [language, serviceName]);
  return null;
}
